export default __webpack_public_path__ + "static/media/white_dragon.755c0e30.png";